import type { TGenerationDto } from '@homepal/api-contract'

/**
 * The wire shapes live in @homepal/api-contract and are imported from
 * there directly. What stays here is what cannot: the contract is
 * types-only, and an enum is runtime.
 */

export enum AnalysisGenerationStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
  ABORTED = 'ABORTED',
  FAILED = 'FAILED'
}

export const TERMINAL_GENERATION_STATUSES: AnalysisGenerationStatus[] = [
  AnalysisGenerationStatus.SUCCEEDED,
  AnalysisGenerationStatus.ABORTED,
  AnalysisGenerationStatus.FAILED
]

/**
 * The contract shape whose one enum-typed field each side owns. This
 * binds the type parameter to this side's enum — it is not a
 * pass-through.
 */
export type AnalysisGeneration = TGenerationDto<AnalysisGenerationStatus>

// status_code of a run cancelled by a user, see cancelGeneration.
const CANCELLED_STATUS_CODE = 499

export const isCancelledGeneration = (generation: AnalysisGeneration) =>
  generation.status === AnalysisGenerationStatus.ABORTED &&
  generation.status_code === CANCELLED_STATUS_CODE
